import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { DeleteBrandDialog } from './DeleteBrandDialog'
import { EditBrandDialog } from './EditBrandDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('create', 'update', () => <EditBrandDialog />)
    .with('delete', () => <DeleteBrandDialog />)
    .exhaustive()
}
